module.exports = "/assets/90a1ca9e21c47e6444879b8ff300d01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/K2.png
// module id = 2654
// module chunks = 0